import type {SiteWithAccess} from '@/types/api';

export function getSitePublicUrl(site: Pick<SiteWithAccess, 'custom_domain' | 'url'>): string {
    const customDomain = site.custom_domain?.trim();

    if (!customDomain) {
        return site.url;
    }

    try {
        const url = new URL(`https://${customDomain}`);
        return url.hostname === customDomain.toLowerCase() ? url.toString() : site.url;
    } catch {
        return site.url;
    }
}
